import { responseErrorHandle } from '@/utils/utils';
import { 
  getDepartmentTree, 
  getDownstreamDepartmentSplit, 
  deleteDepartment
} from '../services';

export default {
  namespace: 'department',
  state: {
    departmentTree: [],
    downstreamDepartmentInfo: [],
  },
  effects: {
    * getDownstreamDepartmentInfo ({ payload }, { call, put }) {
      try {
        const res = yield call(getDownstreamDepartmentSplit, payload);
        yield put({
          type: 'setState',
          payload: {
            downstreamDepartmentInfo: res || [], 
          },
        });
      } catch (e) {
        throw (e);
      }
    },
    * getDepartmentTree ({ payload }, { call, put }) {
      try {
        const res = yield call(getDepartmentTree, payload?.institutionId);
        responseErrorHandle(res);
        yield put({
          type: 'setState',
          payload: {
            departmentTree: res.result || [], 
          },
        });
      } catch (e) {
        throw (e);
      }
    },
    * deleteDepartment ({ payload }, { call }) {
      try {
        const res = yield call(deleteDepartment, payload);
        return res
      } catch (e) {
        throw (e);
      }
    },
  },
  reducers: {
    setState (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
